/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * ProductDetailsLandscape
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as utils from "../../../basics/utils";
import VideoFrame from "../../partials/VideoFrame";
import ProductMain from "./ProductMain";
import ProductFree from "./ProductFree";
import ProductDocuments from "./ProductDocuments";
import * as appActions from "../../../store/actions/appActions";
import GalleryController from '../imageGallery/GalleryController';
import { MdPhotoCamera, MdOutlinePhotoCamera, MdSearch, MdSearchOff } from "react-icons/md";
import { BsCameraVideo, BsCameraVideoFill } from "react-icons/bs";

class ProductLandscape extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, headerHeight, toolbarType, path, orientation, iPhone, appModus, galleryGroup, currentContainer, gallerySearch } = this.props.app;

        const dialog = utils.getDialogByPath(path);

        if (dialog.product === '') return null;

        const node = utils.getTreePortfolio(path, false);
        if (node === null) return null;

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        // ###############################################################
        // Linker Bereich der Produktdetails
        // - Großes Produktbild
        // ###############################################################
        const renderLeft = () => {
            return (
                <div className="w-1/2 h-full flex pb-2 px-2 bg-white">
                    <ProductMain node={node} />
                </div>
            )
        }

        // ###############################################################
        // Rechter Bereich der Produktdetails
        // - Freigestelltes Produktbild
        // - Videoliste
        // - Produktdokumente
        // ###############################################################
        const renderRight = () => {

            const renderUpper = () => {

                const renderInnerLeft = () => {
                    return (
                        <div className={"w-3/5 h-full " + (iPhone ? 'px-1' : 'px-2')}>
                            <ProductFree node={node} />
                        </div>)
                }

                const renderInnerRight = () => {
                    return (
                        <div className="w-2/5 h-full flex flex-col overflow-x-hidden pr-2">
                            <ProductDocuments />
                        </div>
                    )
                }

                // ###############################################################
                // renderUpper
                // ###############################################################
                const style = { background: this.debug ? 'yellow' : '' };

                return (
                    <div style={style} className="w-full h-full flex overflow-y-hidden">
                        {renderInnerLeft()}
                        {renderInnerRight()}
                    </div>
                )
            }

            // ###############################################################
            // renderRight
            // ###############################################################
            return (
                <div className="w-1/2 h-full flex flex-col pt-2">
                    {renderUpper()}
                </div>
            )
        }

        const renderVideoList = () => {

            const renderVideo = (d, i) => {
                return (<VideoFrame key={i} fileName={d.name} type='product' />)
            }

            const files = utils.getNodeFiles(node, 'mp4');

            const className = (orientation === 'landscape') ? 'flex-row overflow-x-auto overflow-y-hidden' : 'flex-row overflow-x-auto overflow-y-hidden';

            return (
                <div className={`flex w-full h-full ${className}`}>
                    {appModus === 'Admin' && renderVideo({ name: '_NEW', path: '' })}
                    {files.map((d, i) => renderVideo(d, i))}
                </div>
            )
        }

        const renderGalleryIcon = (tab, idx) => {

            const onClick = () => {
                if (gallerySearch) {
                    this.props.setSearchString('')
                }
                this.props.setGallerySearch(!gallerySearch)
            }

            const renderIcon = () => {
                if (tab.label === 'Videos') {
                    return galleryGroup === idx ? <BsCameraVideoFill /> : <BsCameraVideo />
                }
                if (tab.label === 'Bilder') {
                    return galleryGroup === idx ? <MdPhotoCamera /> : <MdOutlinePhotoCamera />
                }
            }

            const renderSearchIcon = () => {
                if (appModus === 'Admin') return null;
                return gallerySearch ? <MdSearchOff /> : <MdSearch />
            }

            if (tab.label === 'Bilder') {
                return (
                    <div className="w-full text-5xl text-gray-800 px-4 flex itmes-center justify-center gap-4" >
                        <div onClick={() => this.props.setGalleryGroup(idx)}>{renderIcon()}</div>
                        {galleryGroup === idx && <div onClick={onClick}>{renderSearchIcon()}</div>}
                    </div>
                )
            } else {
                return (
                    <div className="w-full text-5xl text-gray-800 px-4 flex itmes-center justify-center" onClick={() => this.props.setGalleryGroup(idx)}>
                        {renderIcon()}
                    </div>
                )
            }

        }

        const renderGalleryGroup = () => {
            const className = "w-full h-1/2 px-2 text-center font-bold text-xl flex items-center justify-center"
            const classNameAus = `${className} text-gray-400 border-l-8 border-transparent`;
            const classNameEin = `${className} text-black border-l-8 border-gray-800`;

            const tabs = [{ label: "Videos" }, { label: "Bilder" }];

            if (currentContainer === 'regal-lagersysteme') {
                return (
                    <div className="flex w-full">
                        <div className="flex flex-col w-1/12">
                            {tabs.map((tab, idx) => (
                                <div
                                    className={galleryGroup === idx ? classNameEin : classNameAus}
                                    key={tab.label}>
                                    {renderGalleryIcon(tab, idx)}
                                </div>
                            ))}
                        </div>
                        <div className="flex flex-col w-11/12">
                            {galleryGroup === 0 && renderVideoList()}
                            {galleryGroup === 1 && GalleryController()}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="flex w-full">
                        {renderVideoList()}
                    </div>
                )
            }
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        const style = {
            top: headerHeight + 'px',
            height: inputHeight + 'px'
        };

        if (!(dialog.dialogType === 'products' && orientation === 'landscape')) return null;

        if (['search', 'filter', 'favored'].includes(toolbarType)) return null;

        return (
            <div className="w-full h-full ProductLandscape" style={style}>
                <div className="w-full h-4/5 flex z-20 bg-forsales-gray overflow-hidden">
                    {renderLeft()}
                    {renderRight()}
                </div>
                <div className="w-full h-1/5 flex z-20 bg-forsales-gray">
                    {renderGalleryGroup()}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductLandscape);
